export default __webpack_public_path__ + "static/logos-image-a969e6611de96b8ae898b8129ec4de86.svg";